
import { supabase } from "@/integrations/supabase/client";
import { QueryResult } from "../types";

/**
 * Queries related to contract timelines
 */
export const timelineQueries = {
  // Get contracts timeline
  getContractsTimeline: async (year?: number): Promise<QueryResult> => {
    try {
      const currentYear = year || new Date().getFullYear();
      const startOfYear = new Date(currentYear, 0, 1).toISOString();
      const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59).toISOString();
      
      const { data, error } = await supabase
        .from('contracts')
        .select('signed_date')
        .gte('signed_date', startOfYear.split('T')[0])
        .lte('signed_date', endOfYear.split('T')[0]);
      
      if (error) throw error;
      
      // Group by month
      const timelineByMonth: Record<string, number> = {};
      
      // Initialize all months with 0 to ensure we have all months in the timeline
      for (let month = 0; month < 12; month++) {
        const date = new Date(currentYear, month, 1);
        const monthYear = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
        timelineByMonth[monthYear] = 0;
      }
      
      // Populate with actual data
      data.forEach(contract => {
        if (contract.signed_date) {
          const date = new Date(contract.signed_date);
          const monthYear = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
          timelineByMonth[monthYear] = (timelineByMonth[monthYear] || 0) + 1;
        }
      });
      
      // Convert to array and sort chronologically
      const timeline = Object.entries(timelineByMonth)
        .map(([date, count]) => ({ date, count }))
        .sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateA.getTime() - dateB.getTime();
        });
      
      return {
        data: { timeline },
        error: null
      };
    } catch (error) {
      console.error("Error fetching contracts timeline:", error);
      return {
        data: { timeline: [] },
        error
      };
    }
  }
};
